export default function validateTime(e) {
  if (Array.isArray(e)) {
    return e.map((item) => {
      item = String(item).replace(':', '');
        return `${item[0] + item[1]}:${item[2] + item[3]}`
    });
  }

  return [];
}
